<section [class]="{ 'product-cast': true, 'show-row': showRow() }">
  <div class="product-cast-header">
    <h2>عوامل و بازیگران</h2>
  </div>
  <div class="navigation-wrapper">
    @if (generalService.isSmallScreen()) {
      <div class="mobile-slider">
        @if (displayedCasts().length) {
          @for (item of displayedCasts(); track $index) {
            <a class="mobile-slider-item" routerLink="/a/{{ item.artist.descriptor }}">
              <app-image-generator
                [sizes]="artistSizes"
                [name]="item.artist.fullName"
                [src]="item.artist.imagePath"
                imageType="square"
              />
              <div class="artist-name">{{ item.artist.fullName }}</div>
              <div class="artist-roles">{{ item.roles }}</div>
            </a>
          }
        }
      </div>
    } @else {
      <div class="desktop-slider">
        <div class="keen-slider keen-slider--vertical" #sliderRef>
          @if (displayedCasts().length) {
            @for (item of displayedCasts(); track item) {
              <a class="artist-box keen-slider__slide" routerLink="/a/{{ item.artist.descriptor }}">
                <app-image-generator
                  [sizes]="artistSizes"
                  [name]="item.artist.fullName"
                  [src]="item.artist.imagePath"
                  imageType="square"
                />
                <div class="artist-name">{{ item.artist.fullName }}</div>
                <div class="artist-roles">{{ item.roles }}</div>
              </a>
            }
          }
        </div>
        @if (displayedCasts().length > perViewCounter()) {
          <button
            (click)="prevSlide()"
            [class]="{ 'navigation-button': true, 'prev-slide-button': true, __disabled: currentSlide() === 0 }"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button
            (click)="nextSlide()"
            [class]="{
              'navigation-button': true,
              'next-slide-button': true,
              __disabled: displayedCasts().length - perViewCounter() === currentSlide(),
            }"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
        }
      </div>
    }
  </div>
</section>
